module.exports = "/_next/static/images/6259fb9a3c69f9b14ca4902a144ef0e9-bubble-gum-woman-square@xs-1x.jpg.webp";